import { Formik, Form } from 'formik'
import { FC, useState } from 'react'
import Column from '@components/column'
import FieldOverview from '@commons/cards/fieldOverview'
import { useSelector } from 'react-redux'
import Typography from '@components/typography'
import Modal from '@components/modal'
import Fields from '@components/fields'
import Button from '@components/button'
import { User } from '@apis'
interface BioProps {
  title?: string
}
const Bio: FC<BioProps> = ({ title = 'Description' }) => {
  const { data: user } = useSelector((state: any) => state.user)
  const [visible, setVisible] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const submitHandler = async (values) => {
    setLoading(true)
    await User.update({
      id: user?.id,
      data: {
        infos: {
          bio: values?.bio,
        },
      },
    })
      .then(() => {
        setVisible(false)
      })
      .catch(() => {})
    setLoading(false)
  }
  return (
    <Column>
      <FieldOverview
        title={title}
        icon="edit"
        onClick={() => {
          setVisible(true)
        }}
      >
        {!!user?.infos?.bio ? (
          <Typography
            content={user?.infos?.bio}
            size={12}
            tc="text"
            lineHeight={20}
          />
        ) : (
          <Typography content={`Add ${title}....`} size={12} tc="text" />
        )}
      </FieldOverview>
      <Modal
        visible={visible}
        title={`Add ${title}`}
        onClose={() => {
          setVisible(false)
        }}
      >
        <Formik
          initialValues={{
            bio: user?.infos?.bio || '',
          }}
          onSubmit={submitHandler}
          enableReinitialize
        >
          {({ handleSubmit }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <Column rowGap={20}>
                  <Fields.TextArea
                    name="bio"
                    rows={2}
                    placeholder={`Add ${title}....`}
                    required
                  />
                  <Button
                    type="submit"
                    title="Submit"
                    styleButton="width:100%;"
                    height={40}
                    loading={loading}
                  />
                </Column>
              </Form>
            )
          }}
        </Formik>
      </Modal>
    </Column>
  )
}

export default Bio
